import { Subject } from '~/rage/utils';
import { SpawnPointType } from '~/shared';
import { ISpawnSelectService } from './spawnSelectServiceTypes';

export class SpawnSelectServiceStub implements ISpawnSelectService {
	private spawnPoints = new Subject<{ name: string; type: SpawnPointType }[]>([
		{ name: 'Дом 1', type: SpawnPointType.ESTATE },
		{ name: 'Дом 2', type: SpawnPointType.ESTATE },
		{ name: 'Квест сбор малины', type: SpawnPointType.ACTIVE_QUEST },
		{ name: 'Последняя точка выхода', type: SpawnPointType.LAST_POSITION },
	]);
	private selectedSpawnPointIndex = new Subject<number>(0);

	public getSpawnPoints() {
		return this.spawnPoints;
	}

	public getActiveSpawnPointIndex() {
		return this.selectedSpawnPointIndex;
	}

	public async selectActiveSpawnPoint(): Promise<void> {
		console.log('spawnSelect: selectActiveSpawnPoint');
	}

	public async setSpawnPointIndex(index: number): Promise<void> {
		console.log('spawnSelect: setSpawnPointIndex', index);
		this.selectedSpawnPointIndex.next(index);
	}

	public async backToCharacterSelection(): Promise<void> {
		console.log('spawnSelect: backToCharacterSelection');
	}
}
